import { doc, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

export async function touchHouseholdPlanMeta(householdId: string, updatedByUid: string): Promise<void> {
    await setDoc(
        doc(db, 'householdPlanMeta', householdId),
        {
            householdId,
            lastUpdatedAt: new Date().toISOString(),
            lastUpdatedByUid: updatedByUid,
        },
        { merge: true },
    );
}
